module.exports = __webpack_public_path__ + "static/media/B (3).c1dbbd70.jpg";